import React from "react";
import { Form, Slider } from "antd";
import i18n from "i18next";
import ColorPicker from "../../tools/common/ColorPicker";
import { ICONS } from "../../../constants/Icons";

const IconPropertiesPanel = ({ form, selectedItem, canvasRef }) => {

  const addNewIcon = (icon) => {
    canvasRef.handler.drawingHandler.updateProperties(selectedItem, "iconType", icon);
  };

  return (
    <>
      <h3>{i18n.t("propertyBar.shapes.title")}</h3>

      <div className="rde-icons-container">
        {ICONS.map((icon) => (
          <button
            key={icon.id}
            type="button"
            className={`rde-icons-container-btn ${selectedItem.name === icon.id ? "active" : ""
              }`}
            onClick={() => addNewIcon({ svg: icon.svg, id: icon.id })}
            dangerouslySetInnerHTML={{ __html: icon.svg }}
          />
        ))}
      </div>

      <Form.Item
        label={i18n.t("propertyBar.icon.fontIcon")}
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
      >
        {form("scaleX", {
          initialValue: selectedItem.scaleX,
        })(<Slider min={0.1} step={0.1} max={2} />)}
      </Form.Item>

      <Form.Item
        label={i18n.t("propertyBar.shapes.fillColor")}
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
      >
        {form("fill", {
          initialValue:
            selectedItem?.fill || "rgba(0, 0, 0, 1)",
        })(<ColorPicker />)}
      </Form.Item>
    </>
  );
};

export { IconPropertiesPanel };